import { createContext, useContext, useState, ReactNode } from 'react'

interface ChatState {
  isChatOpen: boolean
  setIsChatOpen: (isOpen: boolean) => void
}

const ChatStateContext = createContext<ChatState | undefined>(undefined)

interface ChatStateProviderProps {
  children: ReactNode
}

export function ChatStateProvider({ children }: ChatStateProviderProps) {
  const [isChatOpen, setIsChatOpen] = useState(false)

  return (
    <ChatStateContext.Provider value={{ isChatOpen, setIsChatOpen }}>
      {children}
    </ChatStateContext.Provider>
  )
}

export function useChatState() {
  const context = useContext(ChatStateContext)
  if (context === undefined) {
    throw new Error('useChatState must be used within a ChatStateProvider')
  }
  return context
}